export const textsData = [
  {
    title: 'Бесплатное обучение',
    text: 'ASTON оплачивает программу полностью — от тебя нужны только время и вовлечённость',
  },
  // Убрано в соответствии с задачей AST-7600
  // {
  //   title: 'Финансовая поддержка',
  //   text: 'Поддержка во время стажировки 60 000 ₽ / мес, чтобы ты мог сосредоточиться на практике',
  // },
  {
    title: 'Опытные наставники',
    text: 'Действующие управленцы. Личная помощь и разбор примеров из реальной практики',
  },
  {
    title: 'Предложение работы',
    text: 'Потенциальная стартовая позиция после программы от 120 000 ₽ гросс',
  },
];
